import { render, staticRenderFns } from "./shuttleFrame.vue?vue&type=template&id=2771b57d&scoped=true&"
import script from "./shuttleFrame.vue?vue&type=script&lang=js&"
export * from "./shuttleFrame.vue?vue&type=script&lang=js&"
import style0 from "./shuttleFrame.vue?vue&type=style&index=0&id=2771b57d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2771b57d",
  null
  
)

export default component.exports